export default __webpack_public_path__ + "static/media/explore-3.2edd1473.jpg";